import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import api from '../../utils/api';
import { useAuth } from '../../hooks/useAuth';
import '../../styles/global.css';

export default function EmployeeLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await api.post('/auth/employee/login', data);
      login(res.data.token, res.data.employee, res.data.employee.role);
      navigate('/employee/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--light-bg)' }}>
      <div className="topbar">
        <div className="topbar-logo">
          <div className="topbar-logo-dot" />
          Affordable Telecom LLC
        </div>
        <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12, fontWeight: 600, letterSpacing: '0.1em' }}>
          EMPLOYEE PORTAL
        </div>
      </div>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ width: '100%', maxWidth: 420 }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{ width: 56, height: 56, background: 'var(--navy)', borderRadius: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: 24 }}>
              🏢
            </div>
            <h1 style={{ fontSize: 24, fontWeight: 800, color: 'var(--navy)', marginBottom: 6 }}>
              Employee Sign In
            </h1>
            <p style={{ color: 'var(--text-sub)', fontSize: 14 }}>
              Affordable Telecom LLC — Staff Portal
            </p>
          </div>

          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                  <label className="form-label">Work email address</label>
                  <input type="email" className={`form-input${errors.email ? ' error' : ''}`}
                    placeholder="you@affordabletelecom.com"
                    {...register('email', { required: true })} />
                  {errors.email && <div className="form-error">Email is required</div>}
                </div>
                <div className="form-group">
                  <label className="form-label">Password</label>
                  <input type="password" className={`form-input${errors.password ? ' error' : ''}`}
                    placeholder="Your password"
                    {...register('password', { required: true })} />
                  {errors.password && <div className="form-error">Password is required</div>}
                </div>
                <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
                  {loading ? <><div className="spinner" style={{ width: 16, height: 16 }} /> Signing in...</> : 'Sign In'}
                </button>
              </form>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <Link to="/landlord/login" style={{ color: 'var(--text-sub)', fontSize: 13 }}>Landlord portal →</Link>
            <span style={{ color: 'var(--border)', margin: '0 8px' }}>|</span>
            <Link to="/login" style={{ color: 'var(--text-sub)', fontSize: 13 }}>Tenant portal →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
